import React from "react";
import "./DisableBillModal.scss";
import Modal from "../Modal/Modal";

const DisableBillModal = ({
  isOpen,
  onClose,
  title,
  icon,
  btnCancel,
  btnConfirm,
  disable,
  header,
}) => {
  return isOpen ? (
    <div className="" data-testid={'DisableModal'}>
      <Modal
        icon={icon}
        show={isOpen}
        onClose={onClose}
        title={header}
        description={title}
        type={"button"}
        styleType={"secondary"}
        onFirstClick={onClose}
        linkTitle={btnCancel}
        typeSecond={"button"}
        onSecondClick={disable}
        linkTitleSecond={btnConfirm}
      />
    </div>
  ) : null;
};

export default DisableBillModal;
